export const dashboard = {
  title: '儀表板',
  subtitle: '總覽您的 AI 電話業務數據與活動',
  
  //  Plan & Balance
  currentPlan: '目前方案',
  planExpiry: '方案到期日',
  callBalance: '電話餘額',
  usedToday: '今日已使用',
  minutes: '分鐘',
  
  //  KPI
  todayKPI: '今日 KPI',
  totalCalls: '撥打通數',
  successCalls: '成功接通',
  successRate: '成功率',
  avgDuration: '平均時長',
  calls: '通',
  rate: '比率',
  
  //  Trend
  weeklyTrend: '近 7 天趨勢',
  
  //  Recent Activity
  recentTasks: '最新任務',
  recentCalls: '最新通話',
  taskName: '任務名稱',
  task: '任務',
  result: '結果',
  duration: '時長',
  statusActive: '進行中',
};
